import React, { useState, useContext } from 'react';
import { UserContext } from '../components/userContext';
import { Link, useHistory } from 'react-router-dom';
import axios from 'axios';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import VisibilityRoundedIcon from '@material-ui/icons/VisibilityRounded';
import VisibilityOffRoundedIcon from '@material-ui/icons/VisibilityOffRounded';
import CachedRoundedIcon from '@material-ui/icons/CachedRounded';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import {Container, FormControl, InputLabel, OutlinedInput} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  paper: {
    // marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: '#fff',
  },
  form: {
    '$ $input': {
      backgroundColor: 'none'
    },
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
    '& .MuiFormLabel-root.Mui-focused': {
      color: 'rgb(163, 102, 255)',
    },
    '& .Mui-focused': {  
      '& .MuiOutlinedInput-notchedOutline': {
        border: '2px solid rgb(163, 102, 255)'
      }
    },
  },
  formControl: {
    marginTop: 16,
    marginBottom: 8,
    width: '100%',
    '& .MuiIconButton-root:hover,': {
      backgroundColor: 'transparent'
    },
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  }
}));

export default function ChangePassWord() {
  const classes = useStyles();
  const { user, setUser } = useContext(UserContext);  
	const [ input, setInput ] = useState({current_password: '', new_password: '', new_confirm_password: '', showPassword: false});
	let history = useHistory();

  const handleClickShowPassword = () => {
    setInput({ ...input, showPassword: !input.showPassword });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleSubmit = (event) => {
		event.preventDefault();

		if( user ) { 
			console.log(user)
      axios.post('https://backendexample.sanbersy.com/api/change-password', {
        ...user,
        current_password: input.current_password,
        new_password: input.new_password,
        new_confirm_password: input.new_confirm_password
      }, {headers: {"Authorization" : "Bearer " + user.token}}).then(() => {
        alert('Your password has been changed')
        history.push('/');
      })
      setInput({current_password: '', new_password: '', new_confirm_password: ''});
		}
	}

  const handleChange = (event) => {
		let value = event.target.value;
		let name = event.target.name;
		setInput({...input, [name]: value})
		// Long way method
		// switch (name) {
		// 	case 'name': {
		// 		setInput({...input, name: value});
		// 		break;
		// 	}
		// 	case 'email': {
		// 		setInput({...input, email: value});
		// 		break;
		// 	}
		// 	case 'password': {
		// 		setInput({...input, password: value});
		// 		break;
		// 	}
		// 	default: {break;}
		// }
		console.log(input);
	}

  return (
    <Container maxWidth="xs" style={{padding: 0}}>
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <CachedRoundedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Change Password
        </Typography>
        <form className={classes.form} onSubmit={handleSubmit}>
          <TextField
            variant="outlined"
            margin="normal"
            fullWidth
            value={user.email}
            disabled
          />
          <FormControl className={classes.formControl} variant="outlined">
            <InputLabel htmlFor="current_password">Current Password *</InputLabel>
            <OutlinedInput
              required
              fullWidth
              autoFocus
              name="current_password"
              id="current_password"
              onChange={handleChange}
              value={input.current_password}
              type={input.showPassword ? 'text' : 'password'}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {input.showPassword 
                    ? <VisibilityRoundedIcon style={{color: 'rgba(144, 144, 144, 1)'}} /> 
                    : <VisibilityOffRoundedIcon style={{color: 'rgba(144, 144, 144, 1)'}} />}
                  </IconButton>
                </InputAdornment>
              }
              labelWidth={145}
            />
          </FormControl>
          <FormControl className={classes.formControl} variant="outlined">
            <InputLabel htmlFor="new_password">New Password *</InputLabel>
            <OutlinedInput
              required
              fullWidth
              name="new_password"
              id="new_password"
              onChange={handleChange}
              value={input.new_password}
              type={input.showPassword ? 'text' : 'password'}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {input.showPassword 
                    ? <VisibilityRoundedIcon style={{color: 'rgba(144, 144, 144, 1)'}} /> 
                    : <VisibilityOffRoundedIcon style={{color: 'rgba(144, 144, 144, 1)'}} />}
                  </IconButton>
                </InputAdornment>
              }
              labelWidth={125}
            />
          </FormControl>
          <FormControl className={classes.formControl} variant="outlined">
            <InputLabel htmlFor="new_confirm_password">New Confirmed Password *</InputLabel>
            <OutlinedInput
              required
              fullWidth
              name="new_confirm_password"
              id="new_confirm_password"
              onChange={handleChange}
              value={input.new_confirmed_password}
              type={input.showPassword ? 'text' : 'password'}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {input.showPassword 
                    ? <VisibilityRoundedIcon style={{color: 'rgba(144, 144, 144, 1)'}} /> 
                    : <VisibilityOffRoundedIcon style={{color: 'rgba(144, 144, 144, 1)'}} />}
                  </IconButton>
                </InputAdornment>
              }
              labelWidth={205}
            />
          </FormControl>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="secondary"
            className={classes.submit}
          >
            Submit
          </Button>
        </form>
      </div>
    </Container>
  );
}